<template>
  <div id="booking" v-if="booking && !!booking.getEntity()">

    <div class="title">{{ $to(booking.getEntity().getService().name) }}</div>
    <div class="subtitle">{{ $to(booking.getEntity().name) }}</div>

    <div class="section">
      <div class="leftIcon">
        <img src="@/assets/img/icons/calendar_2.png">
      </div>
      <div class="content">
        <div class="subtitle">{{ $t("booking.date") }}</div>
        {{ booking.start.format("DD/MM/YYYY") }}
      </div>
    </div>

    <div class="section">
      <div class="leftIcon">
        <img src="@/assets/img/icons/hours.png">
      </div>
      <div class="content">
        <div class="subtitle">{{ $t("booking.time_slot") }}</div>
        {{ booking.start.format("HH:mm") }} à {{ booking.end.format("HH:mm") }}
      </div>
    </div>

    <div class="section">
      <div class="leftIcon">
        <img src="@/assets/img/icons/bill.png">
      </div>
      <div class="content">
        <div class="subtitle">{{ $t("booking.price") }}</div>
        {{booking.total.toFixed(2)}}$
      </div>
    </div>

    <div class="buttons">
      <div class="btn btn-secondary" @click="back">{{ $t("navigation.back") }}</div>
      <!-- TODO -->
      <div class="btn btn-primary" v-if="isCancelable" @click="cancel">{{ $t("booking.cancel") }}</div>
    </div>

  </div>
</template>

<script>
  import Reservations from "../../core/Reservations";
  import moment from 'moment';

  export default {

    name: "Booking",

    data() {
      return {
        Reservations,
        booking: null
      };
    },

    mounted() {
      this.$store.commit("setDisplay", {
        showHeader: true,
        showHeaderLeft: true,
        showFooter: true,
        headerTitle: "menu.requests",
        headerIcon: "/svg/history.svg"
      });
      this.booking = this.Reservations.get(this.$route.params.id);
      if (!this.booking) {
        this.$router.replace("/bookings");
      }
    },

    computed: {
      isDone() {
        return this.booking.end.isBefore(moment());
      },
      isCancelable() {
        return this.booking && this.booking.getEntity().price === 0 && !(this.isDone || this.booking.getEntity().cancelled);
      }
    },

    methods: {
      back() {
        history.back();
      },
      async cancel() {
        if(this.isCancelable){
          let confirmed = await showConfirmation(this.$t('booking.cancel'), this.$t('booking.cancel_text'), this.$t('yes'), this.$t('no'));
          if(!confirmed) {
            return;
          }
          showSpinner();
          let result;
          try {
            result = await this.booking.cancelReservation();
          } catch(e) {
            showAffirmation(this.$t("error"), this.$to(e.response.data.message));
            hideSpinner();
          }
          hideSpinner();

          if (result.status == 200) {
            this.booking.cancelled = true;
            this.$router.push("/bookings");
          }
        }
      }
    }

  }
</script>

<style lang="scss" scoped>

  #booking {
    background-color: #f2f3f4;
    padding: 20px;
  }

  .title {
    font-size: 20px;
    font-weight: 500;
  }
  .subtitle {
    font-size: 12px;
    color: #808b91;
    margin-bottom: 25px;
  }

  .section {
    display: flex;
    padding: 20px 0;
    border-top: 1px solid #d9dcde;
    .leftIcon {
      width: 20px;
      margin-right: 20px;
      padding-top: 6px;
      text-align: center;
      flex-shrink: 0;
      .svgicon {
        fill: #808b91;
      }
    }
    .content {
      flex-grow: 1;
    }
    .subtitle {
      color: #bfc5c8;
      text-transform: uppercase;
      font-size: 12px;
      margin: 0;
    }
    .line {
      display: flex;
      .grow {
        flex-grow: 1;
      }
    }
    .detailsLine {
      position: relative;
      margin-top: 10px;
      margin-bottom: 20px;
      .icon {
        position: absolute;
        left: -40px;
        .svgicon {
          fill: #808b91;
        }
      }
    }
  }

  .buttons {
    display: flex;
    margin-bottom: 20px;
    .btn {
      flex-grow: 1;
      flex-basis: 0;
    }
    .btn:not(:last-of-type) {
      margin-right: 20px;
    }
  }

</style>
